import { AppBar, Box, BoxProps, Toolbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { drawerWidth } from "../main-menu";

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: "#FAFAFF",
  marginBottom: theme.spacing(1),
  paddingTop: theme.spacing(2),
}));

export const StyledToolbar = styled(Toolbar)({
  minHeight: 64,
  width: "100%",
});

export interface IStyledLogoWrapperProps extends BoxProps {
  isMenuOpen?: boolean;
}

export const StyledLogoWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== "isMenuOpen",
})<IStyledLogoWrapperProps>(({ isMenuOpen, theme }) => ({
  backgroundColor: "#fff",
  border: "1px solid #ebebf7",
  borderRadius: theme.spacing(1),
  width: isMenuOpen ? drawerWidth : 56,
  padding: isMenuOpen ? theme.spacing(0, 2) : theme.spacing(0, 1.5),
}));

export const StyledHeaderWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: "1px solid #ebebf7",
  borderRadius: theme.spacing(1),
  flex: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginLeft: theme.spacing(3),
  height: 58,
  overflow: "hidden",
}));

export interface IStyledProfileWrapperProps extends BoxProps {
  isAuthenticated?: boolean;
}

export const StyledProfileWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== "isAuthenticated",
})<IStyledProfileWrapperProps>(({ isAuthenticated, theme }) => ({
  marginRight: isAuthenticated ? 0 : theme.spacing(2),
  display: "flex",
  gap: theme.spacing(1),
  justifyContent: "space-between",
  alignItems: "center",
  flexShrink: 0,
  minWidth: 0,
  [theme.breakpoints.down("lg")]: {
    gap: 0,
  },
}));

export const StyledDBLogoWrapper = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1.5),
  display: "flex",
  alignItems: "center",
  minWidth: 0,
}));

export const StyledHeaderMiddle = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  minWidth: 0,
  overflow: "hidden",
}));

export const StyledDBLogo = styled(Box)({
  width: "auto",
  height: "25px",
}) as typeof Box;

export const StyledDBName = styled(Typography)({
  fontWeight: 500,
  fontSize: 18,
  lineHeight: "21px",
  color: "#363846",
});

export const StyledCustomerLogoWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  minWidth: 0,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  "@media (max-width: 1511px)": {
    display: "none",
  },
}));

export const StyledCustomerLogo = styled(Box)({
  display: "block",
  maxHeight: 33,
  maxWidth: 200,
  width: "auto",
  height: "auto",
  objectFit: "contain",
}) as typeof Box;
